import { PaymentGatewayType } from '@/helpers/entities/enums/v2/PaymentGatewayType';
import { PaymentOptionType } from '@/helpers/entities/enums/v2/PaymentOptionType';
import { omit } from 'lodash';
import { PaymentOptionModel } from '@/helpers/entities/models/PaymentOptionModel';
export class PaymentGatewayModel {
    constructor(payload) {
        Object.assign(this, omit(payload, 'appPaymentOption'));
        this.optionIsActive = false;
        const paymentOption = payload.appPaymentOption;
        if (paymentOption) {
            this.paymentOption = new PaymentOptionModel(paymentOption);
            this.optionIsActive = this.paymentOption.active;
        }
    }
    get manual() {
        return this.gatewayType === PaymentGatewayType.manual;
    }
    get thirdParty() {
        return this.gatewayType === PaymentGatewayType.thirdParty;
    }
    get bank() {
        return this.paymentOptionType === PaymentOptionType.bank;
    }
    get cod() {
        return this.paymentOptionType === PaymentOptionType.cod;
    }
    get thirdPartyOnlineOption() {
        return this.paymentOptionType === PaymentOptionType.thirdParty;
    }
    get creditCard() {
        return this.paymentOptionType === PaymentOptionType.creditCard;
    }
    get thirdPartyProvider() {
        return this.gatewayType === PaymentGatewayType.provider;
    }
    get optionIsEnable() {
        let optionIsEnable = false;
        if (this.paymentOption) {
            optionIsEnable = this.paymentOption.enable;
        }
        return optionIsEnable;
    }
}
